import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { timeZones } from '../../../../../../../__legacy__/models/timeZones/timeZones.model';
import { ICurrentWorkspaceStore } from '../../../../../../workspaces/currentWorkspace/CurrentWorkspace.store';

export const WorkspaceTimezoneContainer = observer((): ReactElement => {
  const store = useInjection(ICurrentWorkspaceStore.$);

  const { t } = useTranslator();
  const timezone = timeZones.find((tz) => tz.value === store.currentWorkspace.timeZoneOffset);

  return (
    <div className='workspace-timezone-container'>
      {t('projects.details.stats.stats_generated_for')}:&nbsp;<strong>{timezone?.label}</strong>
    </div>
  );
});
